import { withoutTrailingSlash } from 'ufo';
import { navigateTo, useRuntimeConfig } from '#app';
import { usePagesStore } from '~/stores/pages';
import { useLivePreviewStore, useRoute } from '#build/imports';

export type EntryType = 'pages' | 'grants' | 'resources';
export const useEntryPasswordProtected = () => {
  const pagesStore = usePagesStore();
  const route = useRoute();
  const livePreviewStore = useLivePreviewStore();

  const checkEntry = async (path: string, type: EntryType) => {
    const routePath = withoutTrailingSlash(path);

    if (type === 'pages') {
      if (pagesStore.pages[routePath]) {
        return pagesStore.pages[routePath];
      }
    }

    const runtime = useRuntimeConfig();
    const headerName = runtime.generateHeader;
    const headerValue = runtime.generateValue;

    const response = await $fetch<{
      has_password: boolean;
    }>(`${runtime.public.apiUrl}/api/pt/entry-password-field-check`, {
      method: 'POST',
      headers: {
        [headerName]: headerValue,
        'Content-Type': 'application/json',
      },
      body: {
        routePath,
      },
    });

    return response.has_password;
  };

  const redirect = async (type: EntryType, livePreviewHash: string) => {
    if (!livePreviewHash) {
      navigateTo(`/entry-password-protected?type=${type}&redirect=${encodeURIComponent(route.path)}`);
    }

    await livePreviewStore.load(livePreviewHash);
  };

  return { checkEntry, redirect };
};
